import styled from "styled-components";

import { StyledManagementCardSurface } from "app/pages/sales-intelligence/modules/manage-integrations/components/cards-components/styles";

export const StyledAccountSignalTypeSection = styled(StyledManagementCardSurface)`
    scroll-margin-top: 24px;
`;
